import { createSlice } from "@reduxjs/toolkit";

export const snackbar = createSlice({
  name: "snackbar",
  initialState: {
    snacks: {},
  },
  reducers: {
    add: (state, action) => {
      state.snacks[action.payload.id || Date.now()] = action.payload;
    },
    remove: (state, action) => {
      delete state.snacks[action.payload];
    },
  },
});

export const selectors = {
  get: (state) => state.snackbar,
};

/**
 * @param payload -> https://material-ui.com/components/snackbars/
 * @param payload.id {string|number}
 * @param payload.showCircularProgress {boolean}
 * @param payload.severity {'success' | 'info' | 'warning' | 'error'}
 * @param payload.message {string|JSX.Element}
 * @param payload.autoHideDuration {number}
 * @param payload.alertProps {{}} -> https://material-ui.com/components/alert/
 */
export const add = (payload) => snackbar.actions.add(payload);
